import { ReactNode, useEffect, useState } from 'react';
import './tab-nav.scss';
import classNames from 'classnames';

export const TabNav = ({
  tabNames,
  onSelect,
  refreshHash,
  initialTab,
}: {
  tabNames: string[];
  onSelect: (tab: string) => ReactNode;
  refreshHash?: string;
  initialTab?: string;
}) => {
  const [selectedTab, setSelectedTab] = useState<string>();
  const [content, setContent] = useState<ReactNode>();

  function onTabChange(tab: string) {
    setSelectedTab(tab);
    setContent(onSelect(tab));
  }

  useEffect(() => {
    tabNames.length && onTabChange(selectedTab || initialTab || tabNames[0]);
  }, [refreshHash]);

  return (
    <div className="tab-nav">
      <ul className="tabs">
        {tabNames.map((tab, i) => (
          <li key={i} className={classNames('tab', { selected: tab === selectedTab })} onClick={() => onTabChange(tab)}>
            {tab}
          </li>
        ))}
      </ul>
      <div className="tab-content">{content}</div>
    </div>
  );
};
